<template>
  <div id="assessment-list">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="'Assessments'"/>
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="2"
        :menuItems="commonMenuItems.courseSubmitters"
        v-if="userRole === 'telas_course_submitters'"/>
        <dash-sidebar
        defaultSelectedKeys="-1"
        :menuItems="commonMenuItems.admin"
        :defaultSelectedSubKey="selectedSubMenu"
        v-if="userRole === 'telas_telas_administrator'"/>
        <dash-sidebar
        defaultSelectedKeys="2"
        :menuItems="commonMenuItems.assessors"
        :defaultSelectedSubKey="selectedSubMenu"
        v-else />
      <a-layout>
        <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }"
        >
          <a-table
            :columns="columns"
            :rowKey="record => record.assessmentId"
            :dataSource="assignedAssessmentsMeta"
            v-if="$route.name === 'assigned-assessments'"
          >
            <router-link
              slot="assessmentName"
              slot-scope="title, assessmentObj"
              :to="{ name: 'assessment-details', params: { 'assessmentId': assessmentObj.assessmentId } }"
            >
              {{title}}
            </router-link>
          </a-table>
          <a-table
            :columns="columns"
            :rowKey="record => record.assessmentId"
            :dataSource="inProgressAssessmentMeta"
            v-else-if="$route.name === 'in-progress-assessments'"
          >
            <router-link
              slot="assessmentName"
              slot-scope="title, assessmentObj"
              :to="{ name: 'assessment-details', params: { 'assessmentId': assessmentObj.assessmentId } }"
            >
              {{title}}
            </router-link>
          </a-table>
          <a-table
            :columns="completed_columns"
            :rowKey="record => record.assessmentId"
            :dataSource="completedAssessmentMeta"
            v-else
          >
            <router-link
              slot="assessmentName"
              slot-scope="title, assessmentObj"
              :to="{ name: 'assessment-details', params: { 'assessmentId': assessmentObj.assessmentId } }"
            >
              {{title}}
            </router-link>
                <template slot="interim_review_completed_date" slot-scope="text, record">
                 {{ moment.unix(record.sortable_date).format('DD/MM/YYYY') }}
           </template>
          </a-table>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import dashHeader from './Header.vue';
import dashSidebar from './Sidebar.vue';

export default {
  name: 'assessment-list',
  components: {
    dashHeader,
    dashSidebar,
  },
  data() {
    return {
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'Assessments',
          route: '/dashboard/assessments',
        },
      ],
      dashboardTitle: '',
      columns: [
        {
          title: 'Assessment Name',
          dataIndex: 'assessmentName',
          sorter: false,
          scopedSlots: { customRender: 'assessmentName' },
        },
        {
          title: 'Reviewer Name',
          dataIndex: 'reviewer_name',
          sorter: false,
          scopedSlots: { customRender: 'reviewer_name' },
        },
        {
          title: 'Institution Name',
          dataIndex: 'institution_name',
        },
        {
          title: 'Assigned Date',
          dataIndex: 'assigned_date',
          sorter: false,
          scopedSlots: { customRender: 'assigned_date' },
        },
      ],
        completed_columns: [
          {
            title: 'Assessment Name',
            dataIndex: 'assessmentName',
            sorter: false,
            scopedSlots: { customRender: 'assessmentName' },
          },
          {
            title: 'Reviewer Name',
            dataIndex: 'reviewer_name',
            sorter: false,
            scopedSlots: { customRender: 'reviewer_name' },
          },
          {
            title: 'Institution Name',
            dataIndex: 'institution_name',
          },
          {
            title: 'Completed Date',
            dataIndex: 'review_completed_date',
            sorter: (a, b) => a.sortable_date - b.sortable_date,
            defaultSortOrder: 'descend',
            sortDirections: ['descend', 'ascend'],
          },
        ],
      selectedSubMenu: '',
    };
  },
  computed: {
    ...mapState('user', {
      userDetails: state => state.userDetails,
    }),
    ...mapState('assessments', {
      assessments: state => state.assessmentByUser,
    }),
    ...mapGetters('user', {
      userRole: 'getUserRole',
    }),
    ...mapGetters('assessments', {
      assignedAssessmentsMeta: 'assignedAssessmentMeta',
      inProgressAssessmentMeta: 'inProgressAssessmentMeta',
      completedAssessmentMeta: 'completedAssessmentMeta',
    }),
  },
  updated() {
    if (this.$route.name === 'assigned-assessments') {
      this.selectedSubMenu = 'sub-menu-0';
    } else if (this.$route.name === 'in-progress-assessments') {
      this.selectedSubMenu = 'sub-menu-1';
    } else {
      this.selectedSubMenu = 'sub-menu-2';
    }
  },
  mounted() {
    this.$nextTick(() => {
      let getAssignedAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'assigned',
        assessmentStatus: 'assigned',
      };
      getAssignedAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getAssignedAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getAssignedAssessmentsArgs;
      this.getAssessments(getAssignedAssessmentsArgs);
      let getInProgressAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'in-progress',
        assessmentStatus: 'in-progress',
      };
      getInProgressAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getInProgressAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getInProgressAssessmentsArgs;
      this.getAssessments(getInProgressAssessmentsArgs);
      let getCompletedAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'completed',
        assessmentStatus: 'completed',
      };
      getCompletedAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getCompletedAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getCompletedAssessmentsArgs;
      this.getAssessments(getCompletedAssessmentsArgs);
    });
  },
  watch: {
    userDetails() {
      let getAssignedAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'assigned',
        assessmentStatus: 'assigned',
      };
      getAssignedAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getAssignedAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getAssignedAssessmentsArgs;
      this.getAssessments(getAssignedAssessmentsArgs);
      let getInProgressAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'in-progress',
        assessmentStatus: 'in-progress',
      };
      getInProgressAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getInProgressAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getInProgressAssessmentsArgs;
      this.getAssessments(getInProgressAssessmentsArgs);
      let getCompletedAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'completed',
        assessmentStatus: 'completed',
      };
      getCompletedAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getCompletedAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getCompletedAssessmentsArgs;
      this.getAssessments(getCompletedAssessmentsArgs);
    },
  },
  methods: {
    ...mapActions('assessments', {
      getAssessments: 'getAssessments',
    }),
  },
};
</script>
<style scoped>
  ul.course-list-header {
    list-style: none;
    display: flex;
    padding: 0px;
  }
  li.course-name-title {
    flex: 1;
    align-items: flex-start;
  }
  li.assigned-date {
    flex: 0 0 auto;
  }

  li.institution-name {
    flex: 1;
    justify-content: flex-end;
  }
</style>
